import { io } from "jsts";

const reader = new io.WKTReader();

const getGeoPoint = (x, y) => {
    return reader.read(`POINT(${x} ${y})`);
}

const getGeoPolygon = (boundary = []) => {
    if (!boundary.length) return null;
    const boundaryStrings = boundary.map(v => `${v.x} ${v.y}`);
    if (boundaryStrings.length && boundaryStrings[boundaryStrings.length - 1] !== boundaryStrings[0]) {
        boundaryStrings.push(boundaryStrings[0])
    }
    return reader.read(`POLYGON((${boundaryStrings.join(",")}))`);
}

export { getGeoPoint, getGeoPolygon };
